module.exports = "<p>\n  project-details works!\n</p>\n"